import React from "react";
import styles from "./ViewFileFormat.module.scss";
import { UPLOAD_FILE_INSTRUCTIONS } from "@/lib/constants";
import CrossIcon from "@/components/SVGComponents/CrossIcon";

const ViewFileFormat = ({ onClose }) => {
  return (
    <div className={styles.passwordNotes} onClick={(e) => e.stopPropagation()}>
      <strong>Note: <span className={styles.closeIcon}   onClick={(e) => {
    e.stopPropagation();
    onClose();
  }}><CrossIcon /></span></strong>
      File must -
      <ul>
        {UPLOAD_FILE_INSTRUCTIONS.map((instruction) => (
          <li key={instruction}>{instruction}</li>
        ))}
      </ul>
    </div>
  );
};

export default ViewFileFormat;
